/* This class represents a lead of type Free Brochure for recommended communities. */

export default class RecommendedBrochureLead {
  constructor(formData) {
    this.communityId = formData.communityId;
    this.type = 'postRecommendedBrochure';
    this.recoComms = RecommendedBrochureLead.getRecommendedCommunities(formData);
    this.email = formData.email;
    this.zip = formData.postalCode;
    this.international = formData.livesOutside;
    this.phone = formData.phone;
    this.firstName = formData.firstName;
    this.lastName = formData.lastName;
    this.marketId = formData.marketId;
    this.builderId = formData.builderId;
    this.fromPage = formData.fromPage;
    this.guid = formData.guid;
  }

  /**
   * Gets an array with the recommended communities information selected by the user.
   * @param {Object} formData with the form inputs to be submited. 
   */
  static getRecommendedCommunities(formData) {
    const recommendations = [];
    const recommendationsKeys = Object.keys(formData).filter((key) => key.includes('RecoComms'));
    recommendationsKeys.forEach((key) => recommendations.push(JSON.parse(formData[key])));

    return recommendations;
  };
}
